import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { installRafCounter } from '@aeonia/gaia-client';
// The two Outfit weights this page uses. glasses.html's head gets a
// preload link for each of the woff2 files these load (see the
// preloadOutfitFonts Vite plugin in vite.config.ts), so both are already in
// flight before this stylesheet is even parsed and no fallback font flash
// shows.
import '@fontsource/outfit/latin-600.css';
import '@fontsource/outfit/latin-700.css';
import GlassesApp from './GlassesApp';
import PhoneStage from './PhoneStage';
import { loadGatewayBaseUrl } from './runtimeConfig';
import { setGaiaBaseUrl } from './session';
import './glasses.css';

declare global {
  interface Window {
    __sting?: { play(): void; release(): void };
  }
}

// Count every animation frame the page asks for, before React renders anything,
// so tests can prove the page is idle. This is the same wrapper the Phaser
// client installs, so the two tracks are measured the same way.
if (import.meta.env.DEV) {
  installRafCounter();
}

const root = document.getElementById('root');
if (root) {
  const phone = root.dataset.layout === 'phone';
  // A host that serves this build may name its own gateway; read it before
  // the first session is built.
  void loadGatewayBaseUrl().then((gateway) => {
    if (gateway) setGaiaBaseUrl(gateway);
    createRoot(root).render(
      <StrictMode>
        {phone ? <PhoneStage><GlassesApp phone /></PhoneStage> : <GlassesApp />}
      </StrictMode>
    );
  });
}
